module.exports = __webpack_public_path__ + "static/img/tssgif.76cbc1b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tssgif.gif
// module id = 1133
// module chunks = 15 17 21 22 23 28 45 47